var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .ppt-style-0 {\n      fill: #ED6C47;\n    }\n\n    .ppt-style-1 {\n      fill: #FF8F6B;\n    }\n\n    .ppt-style-2 {\n      fill: #D35230;\n    }\n\n    .ppt-style-3 {\n      opacity: 0.1;\n      enable-background: new;\n    }\n\n    .ppt-style-4 {\n      opacity: 0.2;\n      enable-background: new;\n    }\n\n    .ppt-style-5 {\n      fill: url(#SVGID_1_);\n    }\n\n    .ppt-style-6 {\n      fill: #FFFFFF;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-0",
    d: "M309.58,279.81L273.86,17.86h-2.67C141.3,18.24,36.1,123.44,35.72,253.33V256L309.58,279.81z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-1",
    d: "M276.53,17.86h-2.67V256l119.07,47.63L512,256v-2.67C511.62,123.44,406.42,18.24,276.53,17.86z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-2",
    d: "M512,256v2.62c-0.37,129.92-105.6,235.15-235.52,235.52h-5.24c-129.92-0.37-235.15-105.6-235.52-235.52V256H512 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-3",
    d: "M285.77,134.91V389c-0.06,8.83-5.41,16.76-13.57,20.12c-2.6,1.1-5.39,1.67-8.22,1.67H91.92 c-3.33-3.81-6.55-7.86-9.53-11.91c-30.34-40.47-46.71-89.69-46.68-140.26v-5.24c-0.07-45.62,13.26-90.25,38.34-128.36 c2.62-4.05,5.36-8.1,8.33-11.91h181.58C275.97,113.21,285.68,122.91,285.77,134.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-4",
    d: "M273.86,146.81v254.09c0,2.82-0.57,5.62-1.67,8.22c-3.36,8.16-11.29,13.51-20.12,13.57H102.76 c-3.77-3.82-7.38-7.8-10.84-11.91c-3.33-3.81-6.55-7.86-9.53-11.91c-30.34-40.47-46.71-89.69-46.68-140.26v-5.24 c-0.07-45.62,13.26-90.25,38.34-128.36h178.01C264.07,125.11,273.77,134.82,273.86,146.81z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-4",
    d: "M273.86,146.81v230.28c-0.09,12-9.79,21.7-21.79,21.79H82.4c-30.34-40.47-46.71-89.69-46.68-140.26v-5.24 c-0.07-45.62,13.26-90.25,38.34-128.36h178.01C264.07,125.11,273.77,134.82,273.86,146.81z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-4",
    d: "M261.95,146.81v230.28c-0.09,12-9.79,21.7-21.79,21.79H82.4c-30.34-40.47-46.71-89.69-46.68-140.26v-5.24 c-0.07-45.62,13.26-90.25,38.34-128.36h166.1C252.16,125.11,261.86,134.82,261.95,146.81z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.5067,
    y1: -1120.0306,
    x2: 216.4468,
    y2: -823.9694,
    gradientTransform: "matrix(1 0 0 1 0 1228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CA4C28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C5401E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B62F14"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-5",
    d: "M21.83,125.02h218.3c12.05,0,21.83,9.77,21.83,21.83v218.3c0,12.05-9.77,21.83-21.83,21.83H21.83 C9.77,386.98,0,377.2,0,365.15v-218.3C0,134.8,9.77,125.02,21.83,125.02z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ppt-style-6",
    d: "M133.36,183.24c14.21-0.96,28.3,3.17,39.75,11.65c9.55,8.52,14.65,20.96,13.84,33.73 c0.16,8.88-2.21,17.62-6.82,25.21c-4.67,7.46-11.4,13.4-19.37,17.12c-9.12,4.24-19.08,6.33-29.14,6.12H104v51.32H75.72V183.24 H133.36z M103.97,254.89h24.34c7.72,0.57,15.37-1.72,21.52-6.42c5.08-4.88,7.75-11.75,7.28-18.78c0-16-9.3-23.99-27.89-23.99h-25.24 L103.97,254.89L103.97,254.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/PPT-Icon.0e382ef71e774e7f177c6534c4f91e65.svg";
export { ForwardRef as ReactComponent };